<template>
    <div class="f-content">
        <div class="cfooter">
            <div class="cfooter-t">
                <div class="w-1200 box-content flexed">
                    <div class="box">
                        <div class="first">友情链接</div>
                        <div class="sec margin-top-31" style="margin-left: -17px;">
                            <div class="line"><a href="http://www.sasac.gov.cn/" target="_blank">国资委</a>  |</div>
                            <div class="line"><a href="https://www.ndrc.gov.cn/" target="_blank">发改委</a>  |</div>
                            <div class="line"><a href="http://www.miit.gov.cn/" target="_blank">工信部</a>  |</div>
                        </div>
                        <div class="sec margin-top-19" style="margin-left: -17px;">
                            <div class="line"><a href="http://www.samr.gov.cn/" target="_blank">市场监督管理总局</a>  |</div>
                            <div class="line"><a href="http://www.cec-ceda.org.cn/" target="_blank">中国企联</a></div>
                        </div>
                    </div>
                    <div class="box">
                        <div class="first">联系我们</div>
                        <div class="sec margin-top-31"><img src="../assets/footer_phone.png" class="margin-right-5">+86-10-88028738/ +86-10-88028706</div>
                        <div class="sec margin-top-17"><img src="../assets/footer_address.png" class="margin-right-5">北京市海淀区西三环中路10号望海楼C座二层</div>
                        <div class="sec margin-top-17"><img src="../assets/footer_mail.png" class="margin-right-5">cana@cananet.org.cn</div>
                    </div>
                    <div class="box">
                        <div class="first">微信号 中国广告主协会</div>
                        <div class="code">
                            <template v-for="(item, index) in weiXinData">
                                <img :src="item.$img" >
                            </template>
                            <div class="code-text">
                                <div>扫描二维码</div>
                                <div style="margin-top: 17px;">更多详情</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cfooter-b">
                <div class="w-1200 footer-text">
                    <div class="p1">
                      <a href="http://www.beian.miit.gov.cn/" target="_blank">
                        Copyright © 中国广告主协会 版权所有 京ICP备12035627号
                      </a>
                    </div>
                    <div style="margin-top: 10px; text-align: center;">技术支持：昆玥科技</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '../model/api'

    export default {
        data () {
            return {
                msg: '底部',
                weiXinData: []
            }
        },
        components: { // 组件
        },
        computed () { // 计算属性
        },
        methods: {
            setMeg () {
                this.msg = '我是改变后的数据'
            },
            getWeiXin() { // 获取微信公众号
                let vars = {};
                vars.params = {
                    sec: '微信公众号',
                    page: 1,
                    count: 6,
                    status: '已发布'
                };
                api.webget(vars, this, data => {
                    if (data.data) {
                        this.weiXinData = data.data.records;
                        this.weiXinData.map(item => {
                            item.$img = JSON.parse(item.surface)[0].$path + '&preview=true'
                        })
                    }
                });
            },
        },
        beforeCreate () { // 实例刚刚被创建
        },
        created () { //实例已经创建完成
        },
        beforeMount () { // 模板编译之前
        },
        mounted () { // 模板编译完成
            this.getWeiXin();
        },
        beforeUpdate () { // 数据更新之前
        },
        updated () { // 数据更新完毕
        },
        beforeDestroy () { // 实例销毁之前
        },
        destroyed () { // 实例销毁完成
        },
        watch: {
            example: {
                handler (val) {
                    if (val.example) {
                    }
                },
                deep: true
            },
        }
    }
</script>

<style scoped>
    .cfooter {
        height: 280px;
        background: rgba(49, 49, 49, 1);
    }

    .cfooter-t {
        height: 183px;
        border-bottom: 1px solid rgba(229,229,229,.22);
    }

    .cfooter-b {
        height: 96px;
    }

    .box {
        flex: 1;
        text-align: left;
        padding-left: 63px;
        padding-top: 26px;
    }
    .box-content{
        height: 100%;
    }
    .first{
        font-size:16px;
        /*font-family:MicrosoftYaHei;*/
        font-weight:400;
        color:rgba(255,255,255,1);
        position: relative;
    }
    .first::after{
        content: "";
        width:20px;
        height:2px;
        background-color: rgba(255,255,255,1);
        position: absolute;
        left: 0;
        top: 30px;
    }
    .sec{
        font-size:14px;
        /*font-family:MicrosoftYaHei;*/
        font-weight:400;
        color:rgba(204,204,204,1);
        display: flex;
        align-items: center;
    }
    .code{
        width:200px;
        height:99px;
        display: flex;
        align-items: center;
        margin-top: 28px;
    }
    .code img{
        width: 100px;
    }
    .code-text{
        width:90px;
        letter-spacing: 2px;
        font-size:14px;
        margin-left: 10px;
        /*font-family:MicrosoftYaHei;*/
        font-weight:400;
        color:rgba(255,255,255,1);
        display: flex;
        text-align: center;
        flex-direction: column;
    }
    .code-text div{
        width: 100%;
    }
    .line{
        border-bottom: 1px solid rgba(255,255,255,.5);
        padding-bottom: 8px;
        margin-left: 14px;
        letter-spacing: 2px;
        position: relative;
    }
    .line a{
        font-size:14px;
        font-weight:400;
        color:rgba(204,204,204,1);
        text-decoration: none;
    }
    .footer-text{
        font-size:16px;
        /*font-family:MicrosoftYaHei;*/
        font-weight:400;
        color:rgba(255,255,255,1);
        padding-top: 18px;
    }
    .p1{
        width: 530px;
        letter-spacing: 2.3px;
        height: 34px;
        line-height: 34px;
        border-bottom:1px solid rgba(255,255,255,.7);
        margin-left: 335px;
    }
  .p1 a{
    font-size:16px;
    font-weight:400;
    color:rgba(255,255,255,1);
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/cfooter.vue